import React, { ReactElement } from 'react'
import TrustedByExperts from '../TrustedByExperts/TrustedByExperts'
import Protection from './Sections/Protection'
import { frequentlyAskedQuestions } from './Sections/frequentlyAskedQuestionsData'
import FrequentlyAskedQuestions from 'components/FrequentlyAskedQuestions'
import ReadyToGetStarted from '../CommonSections/RedyToGetStarted'
import HeroSection from 'components/Organization/LandingPageCommonComponents/HeroSection'
import { CONTROLDText } from 'ui/CONTROLD'
import HeroIcon from 'images/organization/features/malware/hero.svg'
import FeatureUseCases from '../CommonSections/UseCases/FeatureUseCases'
import malwareUseCasesData from './Sections/malwareUseCasesData'
import CompactFeatures, {
  FeaturesDivider,
  FeaturesItem,
} from 'components/Organization/LandingPageCommonComponents/CompactFeatures'
import DevicesIcon from 'images/organization/features/malware/devices.svg'
import NetworkIcon from 'images/organization/features/malware/network.svg'
import TrustedIcon from 'images/organization/features/malware/trusted.svg'
import AnalyticsIcon from 'images/organization/features/malware/analytics.svg'
import SectionDivider from 'components/Organization/LandingPageCommonComponents/SectionDivider'
import FeaturePageLayout from 'components/Organization/LandingPageCommonComponents/LandingPageLayout'

export default function Malware(): ReactElement {
  return (
    <FeaturePageLayout>
      <HeroSection
        title="Malware Identification and Blocking Platform"
        description={`${CONTROLDText} shields your network by blocking DNS requests made to harmful domains that
            could host malware, ransomware, phishing or other threats.`}
        svg={HeroIcon}
      />

      <CompactFeatures>
        <FeaturesItem icon={DevicesIcon} title="Protect your devices" />
        <FeaturesDivider />
        <FeaturesItem icon={NetworkIcon} title="Network level security" />
        <FeaturesDivider />
        <FeaturesItem icon={TrustedIcon} title="Trusted by experts" />
        <FeaturesDivider />
        <FeaturesItem icon={AnalyticsIcon} title="Powerful analytics tooling" />
      </CompactFeatures>

      <FeatureUseCases
        title="Keep your business focused on what matters"
        data={malwareUseCasesData}
      />
      <SectionDivider />

      <Protection />
      <SectionDivider />

      <TrustedByExperts />
      <SectionDivider />

      <FrequentlyAskedQuestions data={frequentlyAskedQuestions} />
      <SectionDivider />

      <ReadyToGetStarted />
    </FeaturePageLayout>
  )
}
